<template>
    <div class="wrapper">
        <div class="content">
            <div class="title-wrap">填写图形验证码后继续</div>
            <div class="img-wrap">
                <img v-if="captcha && captcha.base64" :src="captcha.base64" @click="getCaptchaImg()"
                    class="codeImage" />
            </div>
            <div class="input-wrap">
                <van-field v-model="captcha.value" maxlength="4" center clearable placeholder="请输入图形验证码" />
            </div>
            <div class="btn-wrap">
                <van-button type="info" size="large" @click="submit()">继续</van-button>
                <div class="btn-cancel">
                    <span @click="cancel()">取消</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getCaptchaImage,
    } from '@/api/user'
    export default {
        data() {
            return {
                captcha: {
                    key: "",
                    value: "",
                    base64: null,
                },
            }
        },
        mounted() {
            this.getCaptchaImg();
        },
        methods: {
            getCaptchaImg() {
                this.captcha.key = "";
                this.captcha.value = "";
                getCaptchaImage().then(res => {
                    if (res && res.key && res.base64_img) {
                        this.captcha.key = res.key;
                        this.captcha.base64 = "data:image/jpeg;base64," + res.base64_img;
                    } else {
                        this.$toast.fail("获取图形验证码失败");
                    }
                })
            },
            submit() {
                if (this.captcha.value == null || this.captcha.value == '') {
                    this.$toast.fail('请填写验证码')
                    return;
                }
                this.$emit('change', this.captcha)
            },
            cancel() {
                this.$emit('cancel');
            }
        },
    }
</script>

<style lang="less" scoped>
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .content {
            width: 80vw;
            height: 300px;
            padding: 8px 16px;
            background-color: #fff;

            .title-wrap {
                text-align: center;
                padding: 8px 0;
                font-size: 16px;
            }

            .img-wrap {
                text-align: center;
                padding: 16px 0;
            }

            .input-wrap {
                border: 1px solid var(--color-main);
                margin-bottom: 32px;
            }

            .btn-wrap {
                .btn-cancel {
                    margin: 16px 0;
                    text-align: center;
                }
            }
        }
    }
</style>